





























































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {},
})
export default class RiwayatNyeri extends Vue {
  @Prop() riwayatNyeri!: string;
  // get stateRiwayatRisikoJatuh() {
  //   return storeAssesmenRisikoJatuh.riwayatRisikoJatuh;
  // }

  getHumanDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }
}
